import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { LoadingService } from 'src/app/services/loading.service';
import { SubscriptionService } from 'src/app/services/subscriptions/subscription.service';

@Component({
  selector: 'app-remove-subscriber-modal',
  standalone: false,
  templateUrl: './remove-subscriber-modal.component.html',
  styleUrl: './remove-subscriber-modal.component.scss'
})
export class RemoveSubscriberModalComponent {
  @Input() showModal = false;
  @Output() showModalChange = new EventEmitter<boolean>();

  @Output() onCancel = new EventEmitter();
  @Output() onRemove = new EventEmitter();

  @Input() consumerTenantId!: string;

  constructor(
    private toastrService: ToastrService,
    private loadingService: LoadingService,
    private translateService: TranslateService,
    private subscriptionService: SubscriptionService
  ) {

  }

  remove() {
    this.loadingService.load(
      this.subscriptionService.removeSubscriber(this.consumerTenantId)
    ).subscribe(() => {
      this.toastrService.success(
        this.translateService.instant('SUBSCRIPTIONS.REMOVED-SUBSCRIBER-SUCCESSFULLY')
      );
      this.onRemove.emit();
      this.close();
    });
  }

  cancel() {
    this.onCancel.emit();
    this.close();
  }

  private close() {
    this.showModal = false;
    this.showModalChange.emit(this.showModal);
  }
}
